export default {
    ConfirmDeleteMsg: 'Bạn có chắc muốn xóa bình luận này không?',
    ConfirmDeleteTitle: 'Xóa bình luận',
    DeleteComment: 'Xóa bình luận',
    EditComment: 'Chỉnh sửa',
    ReplyComment: 'Phản hồi',
    ReplyCommentTextTotal: 'phản hồi',
    SeeMore: 'Xem thêm bình luận...',
    SeeMoreReply: 'Xem thêm phản hồi...',
    SendComment: 'Gửi bình luận',
    AddFile: 'Đính kèm tệp'
  };
  